<template lang="pug">
div
  v-dialog(v-model="requestDocument.show", width="600px")
    v-card
      v-card-title.headline
        | Request another document
      v-card-text
        v-text-field(
          v-model="requestDocument.comment",
          label="Comment",
          outlined,
          hide-details
        )
      v-card-actions
        v-spacer
        v-btn(text, @click="requestDocument.show = false")
          | cancel
        v-btn(
          color="primary",
          :loading="requestDocument.loading",
          @click="requestAnotherDocument"
        ) request

  v-row.pa-4
    h2
      | Mandatory documents
    v-expansion-panels.mt-4(flat, focusable, v-model="panelMandatory")
      Doc(
        v-for="(doc, i) in mandatoryDocs",
        :key="'doc_mand_' + doc.ID",
        :data="doc",
        lawyer="1",
        :badge="getBadge(doc)",
        @request="requestAnotherDocumentModal(doc.ID)",
        @approve="approveDocument(doc.ID)",
        @unapprove="unapproveDocument(doc.ID)"
      )

    h2.mt-4
      | Potential documents
    v-expansion-panels.mt-4(flat, focusable, v-model="panelPotential")
      Doc(
        v-for="(doc, i) in potentialDocs",
        :key="'doc_pot_' + doc.ID",
        :data="doc",
        lawyer="1",
        :badge="getBadge(doc)",
        @request="requestAnotherDocumentModal(doc.ID)",
        @approve="approveDocument(doc.ID)",
        @unapprove="unapproveDocument(doc.ID)"
      )

    h2.mt-4
      | Recommended documents
    v-expansion-panels.mt-4(flat, focusable, v-model="panelRecommended")
      Doc(
        v-for="(doc, i) in recommendedDocs",
        :key="'doc_rec_' + doc.ID",
        :data="doc",
        lawyer="1",
        :badge="getBadge(doc)",
        @request="requestAnotherDocumentModal(doc.ID)",
        @approve="approveDocument(doc.ID)",
        @unapprove="unapproveDocument(doc.ID)"
      )

  v-card.mt-4
    v-card-title(style="word-break: normal")
      | Please confirm that you've reviewed
      | all the documents above
      | and either Approved or Rejected changes to them
    v-card-text 
      v-chip(
        :color="decision.Bool ? 'green' : 'red'",
        text-color="white",
        v-if="decision.Valid"
      ) {{ decision.Bool ? 'Confirmed' : 'Not confirmed' }}
      .d-flex.justify-space-around.pa-4(v-else)
        v-btn(
          color="primary",
          @click="confirmDocuments",
          :loading="isConfirmLoading"
        ) confirm
</template>

<script>
import Doc from "@/components/Cases/Sponsorship/views/Documents/Docs/index.vue";
import { expertAPI } from "@/utils/apiUrls";

export default {
  name: "expert-case-documents",

  components: {
    Doc,
  },

  data: () => ({
    panelPotential: false,
    panelRecommended: false,
    panelMandatory: false,
    isConfirmLoading: false,
    isApproveLoading: false,
    requestDocument: {
      loading: false,
      show: false,
      id: null,
      comment: "",
    },
  }),

  computed: {
    usercase() {
      return this.$store.state.expert.usercase.usercase;
    },

    decision() {
      return this.usercase.documents_review;
    },

    caseID() {
      return this.usercase.ID;
    },

    mandatoryDocs() {
      return this.documents.filter(({ status }) => status === "Mandatory");
    },

    recommendedDocs() {
      return this.documents.filter(({ status }) => status === "Recommended");
    },

    potentialDocs() {
      return this.documents.filter(({ status }) => status === "Potential");
    },

    documents() {
      const docs = this.$store.state.expert.usercase.sponsorship.documents;
      return docs || [];
    },
  },

  mounted() {
    this.$store.dispatch("expert/usercase/sponsorship/refreshDocuments");
  },

  methods: {
    getBadge(doc) {
      let color = null;
      let text = "";
      switch (doc.decision) {
        case "approved":
          color = "success";
          text = "Approved";
          break;
        case "unapproved":
          color = "error";
          text = "Unapproved";
          break;
        case "requested_change":
          color = "warning";
          text = "Request another document";
          break;
        default:
      }
      return { color, text };
    },

    approveDocument(id) {
      this.axios
        .get(
          expertAPI.usercase.sponsorship.documents.ApproveDocumentURL(
            this.caseID,
            id
          )
        )
        .then(() => {
          this.$store.dispatch("expert/usercase/sponsorship/refreshDocuments");
        })
        .catch(console.error);
    },

    unapproveDocument(id) {
      this.axios
        .get(
          expertAPI.usercase.sponsorship.documents.UnapproveDocumentURL(
            this.caseID,
            id
          )
        )
        .then(() => {
          this.$store.dispatch("expert/usercase/sponsorship/refreshDocuments");
        })
        .catch(console.error);
    },

    requestAnotherDocumentModal(id) {
      this.requestDocument.show = true;
      this.requestDocument.id = id;
    },

    requestAnotherDocument() {
      this.requestDocument.loading = true;
      this.axios
        .post(
          expertAPI.usercase.sponsorship.documents.RequestChangeURL(
            this.caseID,
            this.requestDocument.id
          ),
          {
            message: this.requestDocument.comment,
          }
        )
        .then(() => {
          this.requestDocument = {
            loading: false,
            show: false,
            id: null,
            comment: "",
          };
          this.$store.dispatch("expert/usercase/sponsorship/refreshDocuments");
        })
        .catch(console.error);
    },

    confirmDocuments() {
      this.isConfirmLoading = true;
      this.axios
        .get(
          expertAPI.usercase.sponsorship.decision.ConfirmDocumentsURL(
            this.caseID
          )
        )
        .then(() => {
          this.$store.dispatch("expert/usercase/refreshUsercase");
          this.isConfirmLoading = false;
        });
    },
  },
};
</script>
